import * as React from 'react';

export const czFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_456)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#D80C13'
            />
            <mask
                id='mask0_1_456'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_456)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H28V9.33333H0V0Z'
                    fill='#F1F5F9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0L13.3333 10L0 20V0Z'
                    fill='#1A47B8'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_456'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
